const getters = {
  listaTiposDocumentais: (state) => state.listaTiposDocumentais,
  idTipoSelecionado: (state) => state.idTipoSelecionado
}

export default getters
